// Keep in sync with the newest entry in blogPosts.js (first item / latest date).
export const latestBlogPost = {
  slug: "9-global-vps-server-locations-clubhosty-2026",
  title: "9 Global VPS Server Locations at ClubHosty: Deploy Your Server Anywhere in 2026",
  date: "September 18, 2026",
};
